module.exports = __webpack_public_path__ + "img/IMG_3452.d71c32a7.jpg";